<template>
  <div class="layout-main">
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      isSafe: false,
      isFooter: true,
      safeFooterClass: '',
      footerBgClass: ''
    };
  },
  computed: {
    key() {
      return this.$route.path;
    }
  },
  watch: {
    '$route.name': {
      handler() {
        window.scrollTo(0,0);
        // this.resizeLayout(val);
        // if (val === 'Home' || val === 'Ranking' || val === 'PersonalCenter') {
        //   this.$refs.content.scrollTop = 0;
        // }
      },
      deep: true
    }
  },
  created() {

  },
  methods: {
  }
};
</script>

<style lang="less">
  @import "index.less";
</style>
